function One() {
    return (
        <div className="flex w-full bg-[#f9f9f9] p-2 rounded-sm items-center flex-col md:flex-row" id='promise1'> {/* Added bg-gray-100 for a light gray background */}
            <div className="benefits-details w-full md:w-7/12 p-4"> {/* Added padding for better content spacing */}
                <h2 className="text-lg md:text-xl font-bold mb-6 mt-4 text-black leading-tight inline-block relative">
                    <span className="relative z-10">24/7 Toll-Free Holiday Hotline</span>
                    <span className="absolute -bottom-2 left-0 h-1 rounded-md w-[50%] bg-gradient-custom -z-0"></span>
                </h2>

                <p className="text-sm text-black mb-4"><span className="font-medium">Picture this:</span> you're by the pool, sipping your favorite drink, fully relaxed. But oh no—something unexpected pops up. Whether it's flights, transfers, or excursions—whatever the issue, you don't have to worry. With our <span className="text-halo-pink">24/7 Toll-Free Holiday Hotline</span>, we're here to help you, no matter where you are.</p>

                <p className="text-sm text-black mb-4">Most importantly, our team understands that holidays are precious, and we'll resolve things swiftly, so you can get back to enjoying your well-deserved getaway!</p>

                <h3 className="text-lg font-semibold mb-4 mt-4">Why You'll Love This</h3>
                <ul className="custom-bullet pl-5 space-y-2 text-black text-sm">
                    <li><span className="font-medium text-black">Real-Time Support</span> – Never feel stranded. You've got instant access to help anytime you need it.</li>
                    <li><span className="font-medium text-black">Experienced Travel Experts</span> – Our agents know every inch of your destination and are ready to help you navigate any travel hiccup.</li>
                    <li><span className="font-medium text-black">Perfect for Peace of Mind</span> – We're here to make sure you can relax with full confidence in us.</li>
                </ul>

                <div className="bg-white rounded-lg p-4 mt-4"> {/* New container with background */}
                    <div className="flex items-center">
                        <img src="/featureIcons/promise1.svg" alt="halo-promise" className="w-6 h-6 mr-2" />
                        <h3 className="text-lg font-semibold">Our Promise</h3>
                    </div>
                    <p className="text-black mt-2">Rest assured, whether it's day or night, we're just a call away!</p>
                </div>
            </div>
            <div className="benefits-divider w-1/12 bg-gray-300 min-h-full"></div> {/* Ensured divider reaches full height */}

            <div className="hidden md:block w-full md:w-4/12"> {/* Added full width for consistency */}
                <div className="promise-image-column w-full p-4">
                    <img src="/halo-promise/1.png" alt="24/7 Toll-Free Holiday Hotline" className="w-full h-auto object-contain" />
                </div>
            </div>
        </div >
    );
}

export default One;